import { render, staticRenderFns } from "./WidgetsRender.vue?vue&type=template&id=ab6ccda4&scoped=true"
import script from "./WidgetsRender.vue?vue&type=script&lang=js"
export * from "./WidgetsRender.vue?vue&type=script&lang=js"
import style0 from "./WidgetsRender.vue?vue&type=style&index=0&id=ab6ccda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6ccda4",
  null
  
)

export default component.exports